import { HelpOutlineRounded } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import {
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';
import { getInstructionsUrlForChannel } from 'modules/ui/Settings/Integrations/utils/getInstructionsUrlForChannel';

interface AddOrEditIntegrationDrawerHeaderProps {
  title: string;
  subtitle?: string;
  isReauthorizeForm?: boolean;
  integrationChannel: IntegrationChannelViewFragment;
  integrationType: IntegrationType;
}

export const AddOrEditIntegrationDrawerHeader = ({
  title,
  subtitle,
  isReauthorizeForm,
  integrationChannel,
  integrationType,
}: AddOrEditIntegrationDrawerHeaderProps) => {
  const helpCenterInstructionsURL = getInstructionsUrlForChannel(
    integrationChannel,
    integrationType,
  );

  return (
    <Box py={2} px={3} borderBottom="1px solid" borderColor="divider">
      <Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h6" whiteSpace="nowrap">
            {isReauthorizeForm ? `Reauthorize ${title}` : title}
          </Typography>
          {helpCenterInstructionsURL && (
            <IconButton
              size="small"
              onClick={() => {
                window.open(helpCenterInstructionsURL, '_blank');
              }}
            >
              <HelpOutlineRounded fontSize="small" color="primary" />
            </IconButton>
          )}
        </Stack>
        {subtitle && (
          <Typography variant="body2" noWrap color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};
